export default "__VITE_ASSET__MZtcoNST__"